export default "__VITE_ASSET__kw1hUeG$__"